<template>
  <b-modal :id="id" :title="title"
           :body-class="bodyClassName"
           no-close-on-backdrop
           centered :size="size"
           @show="onShowModal"
           @shown="onShownModal">
    <slot name="body"></slot>
    <template #modal-footer>
      <slot name="footer"></slot>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'CcModal',
  props: {
    title: {
      type: String,
      default: '...'
    },
    size: {
      type: String,
      default: 'md'
    },
    id: {
      type: String,
      default: 'cc-modal-center'
    },
    bodyClassName: {
      type: String,
      default: null
    }
  },
  methods: {
    onShowModal() {
      this.$emit('onShowModal')
    },
    onShownModal() {
      this.$emit('onShownModal')
    }
  }
}
</script>

<style scoped>

</style>
